import React from "react";
import { ElementPlacement } from "../../../../../reducers/uploadedBoard";

export default function Placement({
  placement,
}: {
  placement: ElementPlacement;
}) {
  return (
    <div>
      <div>
        {placement.x.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}{" "}
        {placement.unit},{" "}
        {placement.y.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}{" "}
        {placement.unit}
      </div>
      <div>
        {placement.rotation_degrees}°, {placement.mount_type}
      </div>
    </div>
  );
}
